import { Layout } from "antd";
import SideBarMenu from "../SideBar/SideBarMenu";
import TopBar from "../TopBar/TopBar";
import Loader from "../../ui/Loader/Loader";
import styles from "./PageLayout.module.scss";
import classNames from "classnames";
import { useRole } from "../../../features/roles/useRole";

type Props = {
  children: React.ReactNode;
  pageContainerClassName?: string;
  isLoading?: boolean;
};

const PageLayout: React.FC<Props> = ({
  children,
  pageContainerClassName,
  isLoading,
}) => {
  const { isPerformer } = useRole();
  return (
    <Layout className={styles.root}>
      {!isPerformer && <SideBarMenu />}
      <Layout
        className={classNames(styles.loaderContainer, {
          loading: isLoading,
        })}
      >
        <TopBar />
        <div
          // style={hideBreadCrumbs ? containerStyle : DashboardContainerStyle}
          className={classNames(pageContainerClassName, styles.pageContainer)}
        >
          {children}
          {isLoading && <Loader className={styles.loader} />}
        </div>
      </Layout>
    </Layout>
  );
};

export default PageLayout;
